/**
 * Permisos operativos (no CRUD genérico) — compartido FM / BH.
 */
export type ProductVertical = "fm" | "bh";

export type OperationalPermission =
  | "can_confirm_booking"
  | "can_refund_order"
  | "can_override_stock"
  | "can_print_kitchen"
  | "can_manage_schedule"
  | "can_send_campaigns"
  | "can_view_customer_phone"
  | "can_manage_billing"
  | "can_manage_team"
  | "can_manage_branch"
  | "can_manage_catalog"
  | "can_manage_orders"
  | "can_operate_pos"
  | "can_approve_pos_product_edit"
  | "can_view_metrics"
  | "can_manage_integrations"
  | "can_manage_branding"
  | "can_manage_tables";

export type OperationalScope = "tenant" | "branch" | "professional" | "kitchen" | "department";

export const OPERATIONAL_PERMISSION_LABELS: Record<OperationalPermission, string> = {
  can_confirm_booking: "Confirmar turnos / reservas",
  can_refund_order: "Reembolsar / devolver pedidos",
  can_override_stock: "Ajustar stock manualmente",
  can_print_kitchen: "Imprimir comandas / cocina",
  can_manage_schedule: "Gestionar agenda y horarios",
  can_send_campaigns: "Enviar campañas y mensajes",
  can_view_customer_phone: "Ver teléfono de clientes",
  can_manage_billing: "Facturación y suscripción",
  can_manage_team: "Equipo y roles",
  can_manage_branch: "Sucursales",
  can_manage_catalog: "Catálogo y productos",
  can_manage_orders: "Órdenes y operaciones",
  can_operate_pos: "Cobrar y registrar ventas",
  can_approve_pos_product_edit: "Aprobar edición de productos en POS",
  can_view_metrics: "Métricas e informes",
  can_manage_integrations: "Integraciones y pagos",
  can_manage_branding: "Marca y tienda pública",
  can_manage_tables: "Gestionar mesas y reservas de salón",
};
